<template>
  <div class="fts-assign">
    <div class="assign__assignee">
      <div class="assign-assignee-label">Assignees</div>

      <div class="assign-assignee" v-if="viewMode">
        <div class="assign-assignee-wrapper" v-for="(x, ind) in assignData.assignees" :key="`${x}-${ind}`">
          <fts-profile :userName="x" />
        </div>
      </div>
      <fts-select  
        :form-data="assignData"
        :item="{ fieldName: 'assignees' }"
        :options="users"
        label="displayName"
        :reduce="x => x && (x.userName || x.username)"
        :additional-filter-keys="['userName', 'username']"
        multiple
        v-else
      >
        <div slot="selected-option-container" slot-scope="{ option }">
          <fts-profile :profile="option" />
        </div>
        <fts-profile slot="option" slot-scope="{option}" :profile="option" :profilePhotoSize="28">
          <template #profileName="{ userProfile, userProfileName, userProfileUsername }">
            <div class="assignee-option-name">{{userProfileName}}</div>
            <div class="assignee-option-username" v-if="userProfile.displayName">{{userProfileUsername}}</div>
          </template>
        </fts-profile>
      </fts-select>

      <template v-if="viewMode">
        <div class="assign-date-wrapper" v-if="assignData.due">
          <div class="assign-date-label">
            due on <span :class="{'assign-date-due': overdue}">{{moment(assignData.due).format('ll')}}</span>
          </div>
        </div>
      </template>
      <div class="assign-date-wrapper" v-else>
        <div class="assign-date-label" v-if="assignData.due">
          due on
        </div>
        <fts-assign-date v-model="assignData.due" :reference-for="referenceFor" />
        <font-awesome-icon
          :icon="['fas', 'xmark']"
          class="assign-date-action"
          @click="clearDueDate"
          v-if="assignData.due"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import { classificationStore } from '../store/classificationStore';

import FTSAssignDate from './FTSAssignDate';
import FTSSelect from "./FTSSelect";
import FTSProfile from "./FTSProfile";

export default {
  props: {
    assignData: Object,
    viewMode: Boolean,
    referenceFor: String
  },
  components :{
    "fts-assign-date": FTSAssignDate,
    "fts-select": FTSSelect,
    "fts-profile": FTSProfile
  },
  methods: {
    moment,
    clearDueDate() {
      this.$set(this.assignData, "due", null);
    }
  },
  computed: {
    users() {
      if (classificationStore.state.users) {
        const users = [...classificationStore.state.users]
          .filter((x) => !x.disable)
          .reduce((result, x) => {
            if (
                this.assignData && 
                this.assignData.assignees &&
                this.assignData.assignees.some((y) => y === x.username || y === x.userName)
              ) {
              result.selected.push(x);
            } else {
              result.available.push(x);
            }
            return result;
          }, { available: [], selected: [] });

        return [
          ..._.orderBy(users.available, 'displayName', 'asc'),
          ..._.orderBy(users.selected, 'displayName', 'asc')
        ];
      }
      return [];
    },
    overdue() {
      if (this.assignData && this.assignData.due) {
        return moment(this.assignData.due).isBefore(moment().startOf('day'));
      }
    }
  }
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-assign {
  .assign__assignee {
    .assign-assignee {
      @include flex-gap($gap: 0.375rem);
      .assign-assignee-wrapper {
        min-width: 0;
        padding: 0.25rem 0.375rem;
        border-radius: $comfort-border-radius;
        background-color: rgba(var(--fts-gray-100-rgb), 0.75);
      }
    }
    .assign-form-label {
      font-size: 0.875rem;
      line-height: 1.25rem;
      color: var(--fts-text);
    }
    .assign-assignee-label {
      margin-bottom: 0.75rem;
      @extend .assign-form-label;
    }
    .assign-date-wrapper {
      display: flex;
      align-items: center;
      margin-top: 0.75rem;
    }
    .assign-date-label {
      margin-right: 0.375rem;
      @extend .assign-form-label;
    }
    .assign-date-due {
      color: var(--fts-danger);
    }
    .assign-date-action {
      margin-left: 0.5rem;
      font-size: 0.875rem;
      color: var(--fts-default);
      cursor: pointer;
    }
  }
}

.vs__dropdown-menu {
  .assignee-option-name {
    font-size: 0.875rem;
    color: var(--fts-text);
  }
  .assignee-option-username {
    font-size: 0.75rem;
    color: var(--fts-default);
  }
}
</style>